import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

import './ErrorBoundary.sass'

declare const __DEV__: boolean

interface MyProps {
  children: React.ReactNode
}
interface MyState {
  hasError: boolean
  details?: object

}
class ErrorBoundary extends React.Component <MyProps, MyState> {

  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static propTypes = {
    children: PropTypes.node
  }

  static getDerivedStateFromError (error) {
    return {
      hasError: true,
      details: error
    }
  }

  handleReload = () => {
    window.setTimeout(() => window.location.reload(), 0)
  }

  render () {
    if (this.state.hasError) {
      return (
        <div className="error page">
          <div className="logo" />
          <section>
            <div className="illustration" />
            <h1><FormattedMessage id="error" /></h1>
            {
              __DEV__ && this.state.details &&
                <p className="error-dev">{this.state.details.toString()}</p>
            }
            <p><FormattedMessage id="error.text" /></p>
            <Link to="/" className="button filled" onClick={this.handleReload}>
              <FormattedMessage id="reload" />
            </Link>
          </section>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
